import * as ExcelJS from 'exceljs';
import { IExcelTemplate } from "../interfaces/i-excel-template";
import moment from 'moment';

export class SalesPlanTemplate implements IExcelTemplate {
    private base64ToBuffer(base64: string): Uint8Array {
        return Uint8Array.from(atob(base64), c => c.charCodeAt(0));
    }
    createTemplate(workbook: ExcelJS.Workbook, imgs: any[]): ExcelJS.Workbook {
       

        return workbook;
    }
    
    fillData(workbook: ExcelJS.Workbook, data: any[]): void {
        
        let sheetNameIndex = 1;

        let data1 = this.appendDuplicateTitles(data);
        
        data1.forEach((item: any, index: any)=>{
            let row = item;
            
            let rowIndx = 2; // Starting from row 2
            //const worksheet = workbook.addWorksheet('Template1' + sheetNameIndex.toString());
            const worksheet = workbook.addWorksheet(row.sheetName1);
            
            // Set the width of a column
            worksheet!.getColumn('A').width = 15; // Width for column A
            worksheet!.getColumn('B').width = 22; // Width for column B
            worksheet!.getColumn('C').width = 62; // Width for column C
            worksheet!.getColumn('D').width = 15; // Width for column D
            worksheet!.getColumn('F').width = 11; // Width for column F
            worksheet!.getColumn('G').width = 18; // Width for column G
    
            //data.forEach(item => worksheet!.addRow(item));
            
            this.addColumn(worksheet!, "TITLE", `B${rowIndx}`, {font: { bold: true }, border: {top: this.getBorder('thick'),left: this.getBorder('thick'),bottom: this.getBorder('thin'),right: this.getBorder('thin')}})
            this.addColumn(worksheet!, row.projectTitle, `C${rowIndx}`, {font: { bold: false }, border: {top: this.getBorder('thick'),left: this.getBorder('thin'),bottom: this.getBorder('thin'),right: this.getBorder('thick')}})
    
            this.addColumn(worksheet!, "EVENT ID", `B${rowIndx + 1}`, {font: { bold: true }, border: {top: this.getBorder('thick'),left: this.getBorder('thick'),bottom: this.getBorder('thin'),right: this.getBorder('thin')}})
            this.addColumn(worksheet!, row.eventID, `C${rowIndx + 1}`, {font: { bold: false }, border: {top: this.getBorder('thick'),left: this.getBorder('thin'),bottom: this.getBorder('thin'),right: this.getBorder('thick')}})
    
            this.fillCallOuts(worksheet!, row);
            this.fillImages(worksheet!, row);
            this.fillLogo(worksheet!, row);
    
            this.fillBottom(worksheet!, 24, row);
            
            // to fill stores as per the template
            this.fillStores(worksheet!, 3, row.installationStores, row.numberOfStores);
    
            // to fill products as per the template
            this.fillProducts(worksheet!, 36, row.installationProducts);

            if(row.spImages!=null
                && row.spImages != undefined
                && row.spImages.length == 1
            )
            {
                this.fillImage1(worksheet, row.spImages[0].base64Bytes, 1.40, 7, 1, 7, 210, 210);
            }

            if(row.spImages!=null
                && row.spImages != undefined
                && row.spImages.length > 1
            )
            {
                row.spImages.forEach((element:any, index: number) => {
                    if(index ==0)
                    {
                        this.fillImage1(worksheet, element.base64Bytes, 1.40, 7, 1, 7, 210, 210);
                    } 
                    else if(index ==1)
                    {
                        this.fillImage1(worksheet, element.base64Bytes, 2.79, 7, 2, 7, 100, 100);
                    }
                    else if(index ==2)
                    {
                        this.fillImage1(worksheet, element.base64Bytes, 2.99, 9, 1, 14, 100, 100);
                    }
                    else if(index ==3)
                    {
                        this.fillImage1(worksheet, element.base64Bytes, 2.79, 11, 1, 14, 100, 100);
                    }
                    else
                    {
                        this.fillImage1(worksheet, element.base64Bytes, 2.99 , 14, 2, 7, 100, 100);
                    }
                });                
            }

            if(row.spLogos!=null
                && row.spLogos != undefined
                && row.spLogos.length > 1
            )
            {
                row.spLogos.forEach((element:any, index: number) => {
                    if(index ==0)
                    {
                        this.fillImage1(worksheet, element.base64Bytes, 2.10, 20.20, 1, 7, 100, 50);
                    }                   
                    else
                    {
                        this.fillImage1(worksheet, element.base64Bytes, 2.80 , 20.20, 2, 7, 100, 50);
                    }
                });
            }

            sheetNameIndex = sheetNameIndex + 1
        });

    }

    private fillImage1(worksheet: ExcelJS.Worksheet, imgBytes: any
        , c: number, r: number, nc: number, nr: number, w: number, h: number)
    {
        // Load the image from the file system   
        const imageBuffer = this.base64ToBuffer(imgBytes);        
        const imageId = worksheet.workbook.addImage({
        buffer: imageBuffer,
        extension: 'jpeg',
        });

        // Add the image to the worksheet
        worksheet.addImage(imageId, {
            // tl: { col: c, row: r, nativeCol: nc, nativeRow: nr}, // top-left corner
            tl: { col: c, row: r}, // top-left corner
            ext: { width: w, height: h }, // size of the image
        });        
    }

    private fillCallOuts(worksheet: ExcelJS.Worksheet, reportModel: any)
    {
        let keyText = '';
        let callOuts = '';
        
        for (let i = 4; i < 7; i++) {
            keyText = '';
            callOuts = '';
            let bh = {};
            let bv = {};

            if(i==4)
            {
                keyText = "CALLOUTS";
                callOuts = reportModel.callouts;
                bh = {top: this.getBorder('thick'),left: this.getBorder('thick'),bottom: this.getBorder('thin'),right: this.getBorder('thin')};
                bv = {top: this.getBorder('thick'),left: this.getBorder('thin'),bottom: this.getBorder('thin'),right: this.getBorder('thick')};
            }
            else if(i==6)
            {
                bh = {top: this.getBorder('thin'),left: this.getBorder('thick'),bottom: this.getBorder('thick'),right: this.getBorder('thin')};
                bv = {top: this.getBorder('thin'),left: this.getBorder('thin'),bottom: this.getBorder('thick'),right: this.getBorder('thick')};
            }
            else
            {
                bh = {top: this.getBorder('thin'),left: this.getBorder('thick'),bottom: this.getBorder('thin'),right: this.getBorder('thin')};
                bv = {top: this.getBorder('thin'),left: this.getBorder('thin'),bottom: this.getBorder('thin'),right: this.getBorder('thick')};
            }


            this.addColumn(worksheet!, keyText, `B${i}`, {font: { bold: true }, border: bh});
            this.addColumn(worksheet!, callOuts, `C${i}`, {font: { bold: false }, border: bv});
        }

        // Merge cells for the value
        worksheet!.mergeCells('B4:B6'); // Merge cells B4 to B6
        worksheet!.mergeCells('C4:C6'); // Merge cells B4 to B6

        worksheet.getCell('C4').alignment = { wrapText: true };
    }

    private fillImages(worksheet: ExcelJS.Worksheet, reportModel: any)
    {
        let keyText = '';
        let fill: any = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFFFF' } // White fill color
        };

        for (let i = 7; i < 21; i++) {
            keyText = '';
            let bh = {};
            let bv = {};

            if(i==7)
            {
                keyText = "IMAGE";
                bh = {top: this.getBorder('thick'),left: this.getBorder('thick'),bottom: undefined,right: undefined};
                bv = {top: this.getBorder('thick'),left: undefined,bottom: undefined,right: this.getBorder('thick')};
            }
            else if(i==20)
            {
                bh = {top: undefined,left: this.getBorder('thick'),bottom: this.getBorder('thick'),right: undefined};
                bv = {top: undefined,left: undefined,bottom: this.getBorder('thick'),right: this.getBorder('thick')};
            }
            else
            {
                bh = {top: undefined,left: this.getBorder('thick'),bottom: undefined,right: undefined};
                bv = {top: undefined,left: undefined,bottom: undefined,right: this.getBorder('thick')};
            }

            this.addColumn(worksheet!, keyText, `B${i}`, {font: { bold: true }, border: bh, fill: fill});
            this.addColumn(worksheet!, '', `C${i}`, {font: { bold: false }, border: bv, fill: fill});
        }
    }

    private fillLogo(worksheet: ExcelJS.Worksheet, reportModel: any)
    {
        let keyText = '';

        for (let i = 21; i < 24; i++) {
            keyText = '';
            let bh = {};
            let bv = {};

            if(i==21)
            {
                keyText = "LOGO";
                bh = {top: this.getBorder('thick'),left: this.getBorder('thick'),bottom: this.getBorder('thin'),right: this.getBorder('thin')};
                bv = {top: this.getBorder('thick'),left: this.getBorder('thin'),bottom: this.getBorder('thin'),right: this.getBorder('thick')};
            }
            else if(i==23)
            {
                bh = {top: this.getBorder('thin'),left: this.getBorder('thick'),bottom: this.getBorder('thick'),right: this.getBorder('thin')};
                bv = {top: this.getBorder('thin'),left: this.getBorder('thin'),bottom: this.getBorder('thick'),right: this.getBorder('thick')};
            }
            else
            {
                bh = {top: this.getBorder('thin'),left: this.getBorder('thick'),bottom: this.getBorder('thin'),right: this.getBorder('thin')};
                bv = {top: this.getBorder('thin'),left: this.getBorder('thin'),bottom: this.getBorder('thin'),right: this.getBorder('thick')};
            }

            this.addColumn(worksheet!, keyText, `B${i}`, {font: { bold: true }, border: bh});
            this.addColumn(worksheet!, '', `C${i}`, {font: { bold: false }, border: bv});
        }

        // Merge cells for the value
        worksheet!.mergeCells('B21:B23'); // Merge cells C2 to C4
        worksheet!.mergeCells('C21:C23'); // Merge cells C2 to C4
    }

    private fillBottom(worksheet: ExcelJS.Worksheet, rowIndx: number, reportModel: any)
    {
        //rowIndx = 24;

        this.addColumn(worksheet!, '', `B${rowIndx}`, {font: { bold: true }, border: {top: this.getBorder('thick'),left: this.getBorder('thick'),bottom: this.getBorder('thin'),right: undefined}});
        this.addColumn(worksheet!, '', `C${rowIndx}`, {font: { bold: false }, border: {top: this.getBorder('thick'),left: undefined,bottom: this.getBorder('thin'),right: this.getBorder('thick')}});

        this.addColumn(worksheet!, 'MABD', `B${rowIndx + 1}`, {font: { bold: true }, border: {top: this.getBorder('thick'),left: this.getBorder('thick'),bottom: undefined,right: undefined}});
        this.addColumn(worksheet!, (reportModel.mabd ==null? '' : moment(reportModel.mabd).format('MM/DD/YYYY')), `C${rowIndx + 1}`, {font: { bold: false }, border: {top: this.getBorder('thick'),left: undefined,bottom: undefined,right: this.getBorder('thick')}});

        //worksheet.getCell(`C${rowIndx + 1}`).numFmt = 'MM/DD/YYYY'; // Date format MM/DD/YYYY

        let bh = {top: undefined,left: this.getBorder('thick'),bottom: undefined,right: undefined};
        let bv = {top: undefined,left: undefined,bottom: undefined,right: this.getBorder('thick')};

        this.addColumn(worksheet!, 'Event Start', `B${rowIndx + 2}`, {font: { bold: true }, border: bh});
        this.addColumn(worksheet!,  moment(reportModel.startDate).format('MM/DD/YYYY'), `C${rowIndx + 2}`, {font: { bold: false }, border: bv});

        this.addColumn(worksheet!, 'Event End', `B${rowIndx + 3}`, {font: { bold: true }, border: bh});
        this.addColumn(worksheet!, moment(reportModel.endDate).format('MM/DD/YYYY'), `C${rowIndx + 3}`, {font: { bold: false }, border: bv});

        this.addColumn(worksheet!, '# STORES', `B${rowIndx + 4}`, {font: { bold: true }, border: bh});
        this.addColumn(worksheet!, reportModel.numberOfStores, `C${rowIndx + 4}`, {font: { bold: false }, align: { horizontal: 'left' }, border: bv});

        this.addColumn(worksheet!, 'Location', `B${rowIndx + 5}`, {font: { bold: true }, border: bh});
        this.addColumn(worksheet!, reportModel.location, `C${rowIndx + 5}`, {font: { bold: false }, align: { horizontal: 'left' }, border: bv});

        this.addColumn(worksheet!, 'Display Type', `B${rowIndx + 6}`, {font: { bold: true }, border: bh});
        this.addColumn(worksheet!, reportModel.displayType, `C${rowIndx + 6}`, {font: { bold: false }, align: { horizontal: 'left' }, border: bv});

        this.addColumn(worksheet!, 'Product Flow and Replenishment', `B${rowIndx + 7}`, {font: { bold: true }, border: bh});
        this.addColumn(worksheet!, reportModel.productFlow, `C${rowIndx + 7}`, {font: { bold: false }, align: { horizontal: 'left' }, border: bv});

        this.addColumn(worksheet!, 'Retail Offer', `B${rowIndx + 8}`, {font: { bold: true }, border: {top: undefined,left: this.getBorder('thick'),bottom: this.getBorder('thick'),right: undefined}});
        this.addColumn(worksheet!, reportModel.retailOffer, `C${rowIndx + 8}`, {font: { bold: false }, align: { horizontal: 'left' }, border: {top: undefined,left: undefined,bottom: this.getBorder('thick'),right: this.getBorder('thick')}});

    }

    private fillStores(worksheet: ExcelJS.Worksheet, rIndex: number, storesData: any[], noOfStores: string)
    {
        this.addColumn(worksheet!, noOfStores, `F1`, {font: { bold: false }, align: { horizontal: 'center' }, fill: {type: 'pattern', pattern: 'solid', fgColor: { argb: 'd9d9d9' }}, border: {}});

        this.addColumn(worksheet!, 'STORE NO', `F2`, {font: { bold: true }, fill: {type: 'pattern', pattern: 'solid', fgColor: { argb: 'd9d9d9' }}, border: {}});
        this.addColumn(worksheet!, 'HHN COVERAGE', `G2`, {font: { bold: true }, fill: {type: 'pattern', pattern: 'solid', fgColor: { argb: 'd9d9d9' }}, border: {}});

        //let rIndex: number = 3;
        storesData.forEach((item: { storeID: string; }, index: any)=>{
            this.addColumn(worksheet!, item.storeID, `F${rIndex}`, {font: { bold: false }, align: { horizontal: 'center' }, border: {}});    
            rIndex = rIndex + 1;
        });
    }

    private fillProducts(worksheet: ExcelJS.Worksheet, rIndex: number, productsData: any[])
    {        
        this.addColumn(worksheet!, 'UPC', `B35`, {font: { bold: true, size: 12}, fill: {type: 'pattern', pattern: 'solid', fgColor: { argb: 'd9d9d9' }}, border: {top: this.getBorder('thin'),left: this.getBorder('thin'),bottom: this.getBorder('thin'),right: this.getBorder('thin')}});
        this.addColumn(worksheet!, 'Item Description', `C35`, {font: { bold: true, size: 12 }, fill: {type: 'pattern', pattern: 'solid', fgColor: { argb: 'd9d9d9' }}, border: {top: this.getBorder('thin'),left: this.getBorder('thin'),bottom: this.getBorder('thin'),right: this.getBorder('thin')}});
        this.addColumn(worksheet!, 'Walmart ITEM', `D35`, {font: { bold: true, size: 12 }, fill: {type: 'pattern', pattern: 'solid', fgColor: { argb: 'd9d9d9' }}, border: {top: this.getBorder('thin'),left: this.getBorder('thin'),bottom: this.getBorder('thin'),right: this.getBorder('thin')}});
        
        productsData.forEach((item: any, index: any)=>{
            this.addColumn(worksheet, item.upc, `B${rIndex}`, {font: { bold: false}, align: { horizontal: 'left' }, border: {top: this.getBorder('thin'),left: this.getBorder('thin'),bottom: this.getBorder('thin'),right: this.getBorder('thin')}});    
            this.addColumn(worksheet, item.productTitle, `C${rIndex}`, {font: { bold: false}, align: { horizontal: 'left' }, border: {top: this.getBorder('thin'),left: this.getBorder('thin'),bottom: this.getBorder('thin'),right: this.getBorder('thin')}});    
            this.addColumn(worksheet, item.vendorItemNumber, `D${rIndex}`, {font: { bold: false }, align: { horizontal: 'left' }, border: {top: this.getBorder('thin'),left: this.getBorder('thin'),bottom: this.getBorder('thin'),right: this.getBorder('thin')}});    
            rIndex = rIndex + 1;
        });
    }

    private addColumn(worksheet: ExcelJS.Worksheet, value: any, cellAddress: string, cellStyle: any)
    {
        let cellSrc = worksheet!.getCell(cellAddress);
        cellSrc.value = value;
        this.formatCell( cellSrc, cellStyle);
        this.formatCell( cellSrc, cellStyle);
    }

    private formatCell(cell: ExcelJS.Cell, cellStyle: any)
    {       
        cell.font = cellStyle.font;
        cell.border = cellStyle.border;

        if(cellStyle.fill)
        {
            cell.fill = cellStyle.fill;
        }

        if(cellStyle.align)
        {
            cell.alignment = cellStyle.align;
        }
    }

    private getBorder(styleValue: string): any
    {
        return { style: styleValue, color: { argb: 'FF000000' } };
    }

    applyFormatting(workbook: ExcelJS.Workbook): void {
        const worksheet = workbook.getWorksheet('Template1');
    }    

    private sanitizeSheetName(sheetName: string): string {
        // Define the maximum allowed length for an Excel sheet name
        const maxLength = 25;
    
        // Define the characters that are not allowed in Excel sheet names
        const invalidChars = /[:\/\\\?\*\[\]]/g;
    
        // Remove invalid characters
        let sanitized = sheetName.replace(invalidChars, '');
    
        // Trim leading or trailing spaces
        sanitized = sanitized.trim();
    
        // Truncate the string if it exceeds the maximum length
        if (sanitized.length > maxLength) {
            sanitized = sanitized.substring(0, maxLength);
        }
    
        return sanitized;
    }

    

  private appendDuplicateTitles(items: Array<any>) {
    const titleCount: any = {};
  
    // sort data by enddate in descending
    items.sort((a: any, b: any) => new Date(b.endDate).getTime() - new Date(a.endDate).getTime());

    let trimmedTitles = items.map(item => {
        let sheetName = this.sanitizeSheetName(item.projectTitle);
        sheetName = sheetName.toLowerCase();
        return { ...item, sheetName };  // Return the item with the new title
      });

    // change duplicate names and append "title ( count)"
    let result = trimmedTitles.map(item => {
        let title = item.sheetName;
    
        // If the title has been seen before, increment the count and append the count to the title
        if (titleCount[title]) {
          titleCount[title]++;
          title = `${title} (${titleCount[title]})`;  // Append the count in parentheses
        } else {
          titleCount[title] = 1;  // Initialize the count for this title
        }
    
        let sheetName1 = title;
        return { ...item, sheetName1 };  // Return the item with the new title
      });

    return result;
  }
}
